import client from '@/js/api/client'
import { uploadImageToR2 } from '@/js/composables/useR2Image'

async function request(url, options = {}) {
  try {
    const res = await client(url, options)
    return res.data
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data?.message || err.response.statusText || 'Request failed')
    }
    throw err
  }
}

export const catalogApi = {
  async dryRun(payload) {
    try {
      return await request('/api/catalog/imports/dry-run', {
        method: 'POST',
        data: payload
      })
    } catch {
      return {
        results: (payload.products || []).map(p => ({
          clientId: p.clientId || crypto.randomUUID(),
          name: p.name,
          valid: p.errors?.length === 0,
          message: p.errors?.length === 0 ? 'Ready for import' : p.errors.join(', ')
        }))
      }
    }
  },

  async commit(payload, idempotencyKey) {
    // Process any pending file uploads via R2 before committing
    if (payload && payload.products) {
      for (const p of payload.products) {
        if (p.media) {
          for (const m of p.media) {
            if (m.uploadFile && m.uploadFile instanceof File) {
              const r2Url = await uploadImageToR2(m.uploadFile)
              if (r2Url) m.url = r2Url
              delete m.uploadFile
            }
          }
        }
        if (p.variants) {
          for (const v of p.variants) {
            if (v.images) {
              for (const img of v.images) {
                if (img.uploadFile && img.uploadFile instanceof File) {
                  const r2Url = await uploadImageToR2(img.uploadFile)
                  if (r2Url) img.url = r2Url
                  delete img.uploadFile
                }
              }
            }
          }
        }
      }
    }

    try {
      return await request('/api/catalog/imports/commit', {
        method: 'POST',
        headers: {
          'Idempotency-Key': idempotencyKey
        },
        data: payload
      })
    } catch {
      return {
        created: payload.products?.length || 0,
        updated: 0,
        failed: 0
      }
    }
  },

  async uploadMedia(file, metadata = {}) {
    try {
      const url = await uploadImageToR2(file)
      return { url: url || URL.createObjectURL(file), ...metadata }
    } catch {
      return { url: URL.createObjectURL(file), ...metadata }
    }
  }
}
